if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const formData = new FormData(this.form);
      if (this.isGiftEnabled()) {
        const isDuplicateGift = await this.isDuplicateGiftItem(formData);
        if (isDuplicateGift) {
          this.handleErrorMessage('Your product is already in the cart.');
          return;
        }
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.cart) {
            if (this.isGiftEnabled()) {
              await this.addGiftItem();
            }
            window.location = window.routes.cart_url;
            return;
          }

          let renderResponse = response;
          if (this.isGiftEnabled()) {
            const giftResponse = await this.addGiftItem();
            if (giftResponse) renderResponse = giftResponse;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(renderResponse) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(renderResponse);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    async isDuplicateGiftItem(formData) {
      const variantId = formData.get('id');
      if (!variantId) return false;

      try {
        const response = await fetch(`${routes.cart_url}.js`, {
          credentials: 'same-origin',
          headers: {'X-Requested-With': 'XMLHttpRequest'},
        });
        if (!response.ok) return false;

        const cart = await response.json();
        return (cart.items || []).some((item) => {
          if (String(item.variant_id) !== String(variantId)) return false;
          const properties = item.properties || {};
          return Object.keys(properties).some((key) => {
            const normalized = key.toLowerCase();
            if (normalized !== 'occasion' && normalized !== 'occasio') return false;
            const value = properties[key];
            return value != null && String(value).trim() !== '';
          });
        });
      } catch (error) {
        console.error(error);
        return false;
      }
    }

    isGiftEnabled() {
      const giftCheckbox =
        this.querySelector('#gift_enable, #gift-enable') ||
        document.querySelector('#gift_enable, #gift-enable');
      return !!(giftCheckbox && giftCheckbox.checked);
    }

    getGiftVariantId() {
      return window.theme?.giftVariantId || '52331762712914';
    }

    getGiftForTitle() {
      const title = this.dataset.productTitle || '';
      const trimmed = title.trim();
      return trimmed.length ? trimmed : null;
    }

    async addGiftItem() {
      const giftVariantId = this.getGiftVariantId();
      if (!giftVariantId) return null;

      const giftForVariantId = this.form?.querySelector('[name=id]')?.value;
      const giftProperties = {
        _gift_uid: `gift-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      };
      if (giftForVariantId) giftProperties._gift_for = giftForVariantId;
      const giftForTitle = this.getGiftForTitle();
      if (giftForTitle) giftProperties['Gift for'] = giftForTitle;

      const payload = {
        items: [{ id: giftVariantId, quantity: 1, properties: giftProperties }],
      };

      if (this.cart) {
        payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }

      try {
        const response = await fetch(`${routes.cart_add_url}`, {
          ...fetchConfig('javascript'),
          body: JSON.stringify(payload),
        });
        if (!response.ok) return null;
        return response.json();
      } catch (error) {
        console.error(error);
        return null;
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
